/* eslint-disable react/require-default-props */
import React, { ReactNode, useContext } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import styles from './floatingmenu.module.scss';

interface Props {
  children: ReactNode;
  fullWidth?: boolean;
}

function FloatingMenu({ children, fullWidth }: Props) {
  const { theme } = useContext(ThemeContext);

  return (
    <div className={`${styles.floating_menu} ${fullWidth ? styles.floating_menu_fullwidth : ''} ${styles[theme]}`}>
      {children}
    </div>
  );
}

export default FloatingMenu;
